// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609300104/js/" + chunkId + "." + {"44":"e3e0f9c1","225":"03c0215f","481":"c1a4523a","486":"ec665b3e","770":"ee2531c7"}[chunkId] + ".0.8011363204179419.chunk.js";
};